import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/Crystal_Wedding_Logo_Submark_v2.svg'


const _hoisted_1 = { class: "mx-auto max-w-screen-2xl px-4 py-6 sm:px-6 lg:px-8" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "block h-18 w-auto",
  src: _imports_0,
  alt: "Heartful Logo"
}, null, -1)
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "hidden sm:ml-6 sm:flex sm:space-x-8" }
const _hoisted_6 = { class: "-mr-2 flex items-center sm:hidden" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)
const _hoisted_8 = { class: "space-y-1 pb-3 pt-2" }
const _hoisted_9 = { class: "border-t border-gray-200 pb-3 pt-4" }
const _hoisted_10 = { class: "mt-3 space-y-1" }

import { 
		Auth
	} from '@/api/Auth'

	import {
		config
	} from '@/modules/jobs/config'
	
	import {
		store as _userStore
	} from '@/store/user'

	// tailwind
	import {
		Disclosure,
		DisclosurePanel,
		DisclosureButton
	} from '@headlessui/vue'
	import {
		Bars3Icon,
		XMarkIcon
	} from '@heroicons/vue/24/outline'

	
	// vue
	import {
		onBeforeMount,
		ref
	} from 'vue'

	import { 
		useI18n
	} from 'vue-i18n'


	
export default /*#__PURE__*/_defineComponent({
  __name: 'TwNavbar',
  emits: [
		'on-navigate'
	],
  setup(__props, { emit: __emit }) {

	const emit = __emit

	const userStore = _userStore()
	const {t} = useI18n()

	// Check for logged in user
	const navigation = ref<any[]>([])
	const todayModule = ref(config.todaysJobs)

	onBeforeMount(async () => {
		// Load file path of all modules named Nav.vue
		const moduleContext = require.context('@/modules', true, /Nav.ts$/i)

		// Import each component
		const modules = moduleContext.keys()
			.map(moduleContext)
			.map(m => m.nav)

		// Sort them based on the position data prop
		navigation.value = modules.filter(m => {
			return m.show
		}).sort((a,b) => {
			let aPos = a.position
			let bPos = b.position
			if(aPos < bPos) {
				return -1
			}else if(aPos > bPos) {
				return 1
			}else{
				return 0
			}
		})
        
	})

	async function signOut() {
		try {
			await Auth.signOut()
		} 
		catch (error) {
			console.log('error signing out: ', error)
		}
	}

	function navigate() {
		emit('on-navigate')
	}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Disclosure), {
    as: "nav",
    class: "bg-gray-50 sticky top-0 z-[35]"
  }, {
    default: _withCtx(({ open }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: {name: 'Jobs'} }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_unref(userStore).getContactType === 'Staff')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    onClick: navigate,
                    to: todayModule.value.path,
                    class: _normalizeClass(["relative font-gotham", [_ctx.$route.meta.module == todayModule.value.name ? 'text-brand-500 half-border-b' : '', 'hover:half-border-black-b justify-center flex items-center px-2 py-2 font-normal text-sm']])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.todaysJobs")), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "class"]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  onClick: navigate,
                  key: item.name,
                  to: item.to,
                  class: _normalizeClass(["relative font-gotham", [_ctx.$route.meta.module == item.module ? 'text-brand-500 half-border-b' : '', 'hover:half-border-black-b justify-center flex items-center px-2 py-2 font-normal text-sm']])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)(item.name)), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"]))
              }), 128)),
              _createElementVNode("a", {
                href: "#",
                onClick: signOut,
                class: "relative font-gotham hover:half-border-black-b justify-center flex items-center px-2 py-2 font-normal text-sm"
              }, _toDisplayString(_unref(t)('nav.signOut')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(DisclosureButton), { class: "inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand-500" }, {
              default: _withCtx(() => [
                _hoisted_7,
                (!open)
                  ? (_openBlock(), _createBlock(_unref(Bars3Icon), {
                      key: 0,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
                  : (_openBlock(), _createBlock(_unref(XMarkIcon), {
                      key: 1,
                      class: "block h-6 w-6",
                      "aria-hidden": "true"
                    }))
              ]),
              _: 2
            }, 1024)
          ])
        ])
      ]),
      _createVNode(_unref(DisclosurePanel), { class: "sm:hidden" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (_unref(userStore).getContactType === 'Staff')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  onClick: navigate,
                  to: todayModule.value.path
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DisclosureButton), {
                      as: "a",
                      href: "#",
                      class: _normalizeClass(["block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700", {'block border-l-4 border-brand-500 bg-brand-50 py-2 pl-3 pr-4 text-base font-medium text-brand-700': _ctx.$route.meta.module == todayModule.value.name}])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("nav.todaysJobs")), 1)
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                onClick: navigate,
                key: item.name,
                to: item.to
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DisclosureButton), {
                    as: "a",
                    href: "#",
                    class: _normalizeClass(["block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700", {'block border-l-4 border-brand-500 bg-brand-50 py-2 pl-3 pr-4 text-base font-medium text-brand-700': _ctx.$route.meta.module == item.module}])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_unref(t)(item.name)), 1)
                    ]),
                    _: 2
                  }, 1032, ["class"])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_unref(DisclosureButton), {
                as: "a",
                href: "#",
                class: "block px-4 py-2 text-base font-medium text-gray-500 hover:bg-gray-100 hover:text-gray-800",
                onClick: signOut
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('nav.signOut')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})